import { get, includes, forEach } from "lodash";

import { clearZoneEvents } from "../actions/siteEntranceExit/liveEvents";
import { getLatestLog } from "../actions/siteEntranceExit/tabs";

import { getFrDetails, getOcrDetails, getLprDetails } from "./detectionDetails";

export const getDetection = (eventGroup) => {
  if (eventGroup) {
    let capturedImages = new Set();
    let matchedProfile;
    let detectionEvent;

    forEach(get(eventGroup, ["events"]), (e) => {
      if (includes([1, 58, 59, 65, 67, 69], get(e, ["type", "id"]))) {
        detectionEvent = e;
      }
      if (includes([79], get(e, ["type", "id"]))) {
        forEach(get(e, ["images"]), (img) =>
          capturedImages.add(img.url)
        );
      }
      forEach(get(e, ["events"]), (subEvent) => {
        forEach(get(subEvent, ["images"]), (img) =>
          capturedImages.add(img.url)
        );
        forEach(get(subEvent, ["events"]), (subSubEvent) => {
          if (includes([63, 57], get(subSubEvent, ["type", "id"]))) {
            matchedProfile = subSubEvent.profile
              ? subSubEvent.profile
              : matchedProfile;
          }
        });
      });
    });

    let contextPhotos = get(detectionEvent, ["images"]) || [];
    contextPhotos = contextPhotos.map((i) => i.url);

    return {
      capturedImages: Array.from(capturedImages),
      fr: getFrDetails(eventGroup),
      ocr: getOcrDetails(eventGroup),
      lpr: getLprDetails(eventGroup),
      contextPhotos,
      matchedProfile,
    };
  }
  return {
    fr: {},
    ocr: {},
    lpr: {},
  };
};

export const liveEventTimeout = (
  dispatch,
  section,
  zoneId,
  sessionId,
  activeTab
) => {
  console.log("Timeout reached, should clear zone");
  dispatch(clearZoneEvents(section, zoneId, sessionId));
  dispatch(getLatestLog(section, activeTab));
};
